import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export interface UpdateGrowWarehouseInfosRequest {
    countryId: number;
    code: string;
    username?: string;
    status: boolean;
    bufferSize: number;
    dailyLimit: number | null;
}

const UpdateGrowWarehouseInfos = (data: UpdateGrowWarehouseInfosRequest): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateGrowWarehouseInfos,
        method: RequestType.POST,
        data,
    });

const GrowManagementCommand = {
    UpdateGrowWarehouseInfos,
};

export default GrowManagementCommand;
